import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { createRef, PureComponent } from 'react';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import { BREAK_TABLET_SMALL } from '../../config/constants';
import ButtonBlock from '../ButtonBlock';
import Image from '../Image';
import css from './ImageSlider.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ImageSlider = /*#__PURE__*/function (_PureComponent) {
  _inherits(ImageSlider, _PureComponent);

  var _super = _createSuper(ImageSlider);

  function ImageSlider(props) {
    var _this;

    _classCallCheck(this, ImageSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      window.clearTimeout(_this.interval);
      _this.interval = setTimeout(_this.onScrollEnd, 50);
    });

    _defineProperty(_assertThisInitialized(_this), "onScrollEnd", function () {
      var closest = _this.getClosestIndex();

      var index = _this.state.index;

      if (index !== closest) {
        _this.goTo(closest);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getClosestIndex", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          total = _assertThisInitialize.total;

      var imageEl = _this.scroller.current;

      if (!imageEl) {
        return -1;
      }

      var scrollWidth = imageEl.scrollWidth || 0;
      var scrollLeft = imageEl.scrollLeft || 0;
      var offsetWidth = imageEl.offsetWidth || 0;

      if (scrollWidth - offsetWidth <= scrollLeft) {
        return total - 1;
      }

      var firstPassed = Array(total).fill().findIndex(function (image, index) {
        var ref = _this.imageRefs[index].current;
        return ref && ref.offsetLeft && ref.offsetLeft - 1 > scrollLeft;
      });
      var imageIndex = firstPassed - 1;
      return imageIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "goTo", function (index) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          total = _assertThisInitialize2.total;

      if (index < 0 || index === total) {
        return false;
      }

      var scroller = _this.scroller.current;
      var target = _this.imageRefs[index].current;

      if (!scroller || !target) {
        return false;
      }

      var scrollTo = target && target.offsetLeft ? target.offsetLeft : 0;

      _this.scrollTo(scroller, scrollTo);

      _this.setState({
        index: index
      });

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (scroller, scrollLeft) {
      scroller.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "canGoLeft", function () {
      var index = _this.state.index;
      return index !== 0;
    });

    _defineProperty(_assertThisInitialized(_this), "canGoRight", function () {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          total = _assertThisInitialize3.total;

      var index = _this.state.index;

      if (index === total - 1) {
        return false;
      }

      var firstImage = _this.imageRefs[0].current;

      if (!firstImage) {
        return index === 0;
      }

      var imageWidth = firstImage.offsetWidth || 0;
      var numCanShow = Math.floor(windowWidth() / imageWidth);

      if (total - index <= numCanShow) {
        return false;
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "getArrowWrapHeight", function () {
      var width = windowWidth();

      if (width > 2000) {
        return 641;
      }

      if (width > BREAK_TABLET_SMALL) {
        return 441;
      }

      return 341;
    });

    var images = _this.props.images;
    _this.scroller = /*#__PURE__*/createRef();
    _this.imageRefs = [];
    _this.total = images.length;

    for (var idx = 0; idx < _this.total; idx += 1) {
      _this.imageRefs.push( /*#__PURE__*/createRef());
    }

    _this.interval = {};
    _this.state = {
      index: 0
    };
    return _this;
  }

  _createClass(ImageSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var imageEl = this.scroller.current;

      if (imageEl) {
        imageEl.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.interval);
      var imageEl = this.scroller.current;

      if (imageEl) {
        imageEl.removeEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          images = _this$props.images,
          showInsetCaptions = _this$props.showInsetCaptions;
      var index = this.state.index;
      var arrowButtonWrapHeight = this.getArrowWrapHeight();
      return /*#__PURE__*/_jsxs("div", {
        className: css.root,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.images,
          ref: this.scroller,
          children: images.map(function (image, imageIndex) {
            return /*#__PURE__*/_jsxs("div", {
              className: css.imageWrap,
              ref: _this2.imageRefs[imageIndex],
              children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                className: css.image
              }, image)), showInsetCaptions && /*#__PURE__*/_jsx("p", {
                className: css.insetCaption,
                children: image.alt
              })]
            }, image.src);
          })
        }), /*#__PURE__*/_jsx(ButtonBlock, {
          disabled: !this.canGoLeft(),
          height: "".concat(arrowButtonWrapHeight, "px"),
          left: true,
          onClick: function onClick() {
            return _this2.goTo(index - 1);
          }
        }), /*#__PURE__*/_jsx(ButtonBlock, {
          disabled: !this.canGoRight(),
          height: "".concat(arrowButtonWrapHeight, "px"),
          left: false,
          onClick: function onClick() {
            return _this2.goTo(index + 1);
          }
        })]
      });
    }
  }]);

  return ImageSlider;
}(PureComponent);

var imageProps = PropTypes.shape({
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
}).isRequired;
ImageSlider.defaultProps = {
  showInsetCaptions: false
};
ImageSlider.propTypes = {
  images: PropTypes.arrayOf(imageProps).isRequired,
  showInsetCaptions: PropTypes.bool
};
export default ImageSlider;